// 가맹점주 내 문의 현황 · 내 대화 기록 화면 문구(ko·zh). 서버 문장(진행 기록·사유·처리 결과)은 여기에 넣지 않는다.
import { useCallback } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

export const MY_TEXT = {
    ko: {
        "menu.inq": "내 문의 현황",
        "menu.log": "내 대화 기록",
        "menu.logCount": "{n}건",
        "menu.logout": "로그아웃",
        "menu.bizLine": "사업자번호 {biz}",
        "menu.owner": "대표 {name}",
        "back": "뒤로",
        "inq.title": "내 문의 현황",
        "inq.desc": "챗봇·전화로 접수한 우리 매장 문의의 진행 상태와 처리 결과입니다.",
        "tab.all": "전체",
        "tab.open": "진행 중",
        "tab.done": "완료",
        "st.new": "접수",
        "st.processing": "처리 중",
        "st.on_hold": "보류",
        "st.completed": "완료",
        "st.canceled": "취소",
        "ch.chatbot": "챗봇",
        "ch.phone": "전화",
        "wait": "담당자 배정을 기다리고 있어요",
        "assignee": "담당 {names}",
        "visit": "방문 예정 {when}",
        "result": "처리 결과",
        "progress": "처리 내용",
        "hold": "확인이 필요해 잠시 보류 중이에요. 담당자가 연락드릴 예정입니다.",
        "canceled": "접수가 취소된 문의예요.",
        "empty.all": "문의 내역이 없어요.",
        "empty.open": "진행 중인 문의가 없어요.",
        "empty.hint": "첫 화면 메뉴나 채팅으로 문의하면 여기에 쌓입니다.",
        "detail.title": "문의 상세",
        "received": "{when} 접수",
        "f.kind": "구분",
        "f.assignee": "담당자",
        "f.visit": "방문 예정",
        "f.done": "처리일시",
        "visitNote": "{names} 담당자가 {when}에 방문할 예정이에요.",
        "reopened": "이전 문의 No.{id} 재문의",
        "photos": "사진 {n}장",
        "photoBy.customer": "가맹점주",
        "timeline": "진행 기록",
        "append.title": "내용 덧붙이기",
        "append.placeholder": "추가로 전할 내용이나 일정 변경 요청을 적어주세요. 담당자에게 바로 전달돼요.",
        "append.hint": "같은 건으로 새 문의를 만들지 않아도 돼요. 사진도 함께 보낼 수 있어요.",
        "append.addPhoto": "사진 추가 ({left}장 더)",
        "append.caption": "사진 설명 (선택)",
        "append.remove": "빼기",
        "append.submit": "보내기",
        "append.done": "담당자에게 전달했어요.",
        "err.text_required": "내용을 적어주세요.",
        "err.text_too_long": "1,000자까지 적을 수 있어요.",
        "err.not_an_image": "사진 파일만 올릴 수 있어요.",
        "err.file_too_large": "사진은 한 장에 10MB까지예요.",
        "err.too_many_attachments": "사진은 문의당 10장까지예요.",
        "err.caption_too_long": "사진 설명은 50자까지예요.",
        "err.inquiry_closed": "이미 끝난 문의예요. 새로 문의해 주세요.",
        "err.send": "보내지 못했어요. 잠시 뒤 다시 시도해 주세요.",
        "viewChat": "접수한 대화 보기",
        "home": "처음으로",
        "notFound": "찾을 수 없어요.",
        "toList": "목록으로",
        "loadFail": "불러오지 못했어요.",
        "retry": "다시 시도",
        "log.title": "내 대화 기록",
        "log.desc": "챗봇과 나눈 대화를 다시 볼 수 있어요. 최근 90일까지 보관합니다.",
        "log.untitled": "대화",
        "log.msgs": "{n}개 메시지",
        "lang.ko": "한국어",
        "lang.zh": "中文",
        "res.inquiry": "문의 접수 No.{id}",
        "res.answered": "답변 완료",
        "res.failed": "답변 못 함",
        "log.detail": "대화 보기",
        "log.linked": "이 대화로 접수된 문의 No.{id}",
        "log.empty": "최근 90일 대화 기록이 없어요.",
        "list": "목록",
        "close": "닫기",
        "reask": "같은 문제가 다시 생겼어요",
        "resume": "이 대화 이어서 질문하기",
    },
    zh: {
        "menu.inq": "我的咨询",
        "menu.log": "我的对话记录",
        "menu.logCount": "{n}条",
        "menu.logout": "退出登录",
        "menu.bizLine": "营业执照号码 {biz}",
        "menu.owner": "负责人 {name}",
        "back": "返回",
        "inq.title": "我的咨询",
        "inq.desc": "通过聊天机器人或电话提交的本店咨询的处理进度和结果。",
        "tab.all": "全部",
        "tab.open": "处理中",
        "tab.done": "已完成",
        "st.new": "已受理",
        "st.processing": "处理中",
        "st.on_hold": "暂缓",
        "st.completed": "已完成",
        "st.canceled": "已取消",
        "ch.chatbot": "聊天机器人",
        "ch.phone": "电话",
        "wait": "正在等待分配负责人",
        "assignee": "负责人 {names}",
        "visit": "预计上门 {when}",
        "result": "处理结果",
        "progress": "处理内容",
        "hold": "需要确认，暂时搁置。负责人将与您联系。",
        "canceled": "该咨询已取消。",
        "empty.all": "暂无咨询记录。",
        "empty.open": "暂无处理中的咨询。",
        "empty.hint": "通过首页菜单或聊天提交咨询后会显示在这里。",
        "detail.title": "咨询详情",
        "received": "{when} 受理",
        "f.kind": "分类",
        "f.assignee": "负责人",
        "f.visit": "预计上门",
        "f.done": "处理时间",
        "visitNote": "负责人 {names} 预计于 {when} 上门。",
        "reopened": "重新咨询（原咨询 No.{id}）",
        "photos": "照片 {n}张",
        "photoBy.customer": "加盟店主",
        "timeline": "处理记录",
        "append.title": "补充内容",
        "append.placeholder": "请填写需要补充的内容或日程变更请求，将直接转达给负责人。",
        "append.hint": "同一事项无需重新提交咨询，也可以一起发送照片。",
        "append.addPhoto": "添加照片（还可{left}张）",
        "append.caption": "照片说明（选填）",
        "append.remove": "移除",
        "append.submit": "发送",
        "append.done": "已转达给负责人。",
        "err.text_required": "请填写内容。",
        "err.text_too_long": "最多可填写1,000字。",
        "err.not_an_image": "只能上传照片文件。",
        "err.file_too_large": "每张照片不超过10MB。",
        "err.too_many_attachments": "每个咨询最多10张照片。",
        "err.caption_too_long": "照片说明最多50字。",
        "err.inquiry_closed": "该咨询已结束，请重新提交咨询。",
        "err.send": "发送失败，请稍后再试。",
        "viewChat": "查看提交时的对话",
        "home": "返回首页",
        "notFound": "找不到该内容。",
        "toList": "返回列表",
        "loadFail": "加载失败。",
        "retry": "重试",
        "log.title": "我的对话记录",
        "log.desc": "可以重新查看与聊天机器人的对话，保留最近90天。",
        "log.untitled": "对话",
        "log.msgs": "{n}条消息",
        "lang.ko": "韩语",
        "lang.zh": "中文",
        "res.inquiry": "已提交咨询 No.{id}",
        "res.answered": "已回答",
        "res.failed": "未能回答",
        "log.detail": "查看对话",
        "log.linked": "通过此对话提交的咨询 No.{id}",
        "log.empty": "最近90天暂无对话记录。",
        "list": "列表",
        "close": "关闭",
        "reask": "同样的问题又出现了",
        "resume": "继续这段对话提问",
    },
};

// tt("assignee", { names: "이기사" }) — 언어별 문구, {이름} 자리를 바꾼다(없는 키는 한국어 → 키)
export function useMyText() {
    const { lang } = useLanguage();
    return useCallback((key, vars = {}) => {
        const s = (MY_TEXT[lang] || MY_TEXT.ko)[key] ?? MY_TEXT.ko[key] ?? key;
        return s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] ?? m));
    }, [lang]);
}
